/**
 * City-guide registry
 *
 * Registers each state's data file and each migrated city. The `CityDetail`
 * router asks `getCityGuide(citySlug)` — if the city has been migrated to the
 * flagship template, it returns `{ city, state }`. Otherwise returns `null`
 * and the router falls back to the legacy CityTemplate.
 *
 * Adding a new city: create `/data/city-guides/cities/<slug>.js`, import it
 * here, and add it to CITIES.
 *
 * Adding a new state: create `/data/city-guides/states/<slug>.js`, import it
 * here, and add it to STATES.
 */
import { OHIO_STATE_GUIDE } from "./states/ohio";
import { CLEVELAND_CITY } from "./cities/cleveland";
import { COLUMBUS_CITY } from "./cities/columbus";
import { CINCINNATI_CITY } from "./cities/cincinnati";
import { TOLEDO_CITY } from "./cities/toledo";
import { DAYTON_CITY } from "./cities/dayton";

const STATES = {
  ohio: OHIO_STATE_GUIDE,
};

const CITIES = {
  cleveland: CLEVELAND_CITY,
  columbus: COLUMBUS_CITY,
  cincinnati: CINCINNATI_CITY,
  toledo: TOLEDO_CITY,
  dayton: DAYTON_CITY,
};

export function getCityGuide(citySlug) {
  const city = CITIES[citySlug];
  if (!city) return null;
  const state = STATES[city.state_ref];
  if (!state) return null;
  return { city, state };
}

export function hasCityGuide(citySlug) {
  return Boolean(CITIES[citySlug]);
}
